import { render } from "./GridIndustrii.vue?vue&type=template&id=52a9db44&scoped=true&ts=true"
import script from "./GridIndustrii.vue?vue&type=script&lang=ts"
export * from "./GridIndustrii.vue?vue&type=script&lang=ts"

import "./GridIndustrii.vue?vue&type=style&index=0&id=52a9db44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a9db44"]])

export default __exports__